module.exports = "https://web-assets.ifttt.com/packs/media/careers/cover-03cef9c1.jpg";